import { ISourceRegistryRequestModel, ISourceRegistryResponseModel } from '../../../../models';
import {
  clearSourceRegistry,
  createSourceRegistryFail,
  createSourceRegistryStarted,
  createSourceRegistrySuccess
} from '../../../reducer/sources/SourceRegistryReducer';
import { createSourceRegistry } from '../../actionType/sources/SourceRegistryActionTypes';
import {
  ClearSourceRegistries,
  CreateSourceRegistryFailure,
  CreateSourceRegistryFailurePayload,
  CreateSourceRegistryRequest,
  CreateSourceRegistryStarted,
  CreateSourceRegistrySuccess
} from '../../types/sources/CreateSourceRegistryTypes';

export const createSourceRegistryRequest = (sourceRegistryData: ISourceRegistryRequestModel): CreateSourceRegistryRequest => ({
  type: createSourceRegistry.CREATE_SOURCE_REGISTRY_REQUEST,
  sourceRegistryData
});

/**
 * Fetch sourceRegistry started saga action
 * @returns sourceRegistry started action
 */
export const createSourceRegistryStart = (): CreateSourceRegistryStarted => ({
  type: createSourceRegistryStarted.type
});

/**
 * Fetch sourceRegistry success saga action
 * @param payload :sourceRegistry data
 * @returns success action
 */
export const createdSourceRegistrySuccess = (
  payload: ISourceRegistryResponseModel[]
): CreateSourceRegistrySuccess => ({
  type: createSourceRegistrySuccess.type,
  payload
});

/**
 * Fetch SourceRegistry Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const createdSourceRegistryFailure = (
  payload: CreateSourceRegistryFailurePayload
): CreateSourceRegistryFailure => ({
  type: createSourceRegistryFail.type,
  payload
});

/**
 * Clear SourceRegistry saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearedSourceRegistrys = (): ClearSourceRegistries => ({
  type: clearSourceRegistry.type
});
